import React, { useState, useEffect } from 'react';
import Navbar from '../Shared/Navbar';
import api from '../../config/api';
import { Link } from 'react-router-dom';
import './TalentSearch.css';

function TalentSearch({ user, onLogout }) {
  const [results, setResults] = useState([]);
  const [filters, setFilters] = useState({
    style: '',
    material: '',
    garmentType: '',
    location: ''
  });
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    handleSearch();
  }, []);

  const handleSearch = async () => {
    setLoading(true);
    try {
      const response = await api.post('/api/search/creators', 
        { filters, query }
      );
      setResults(response.data.results);
    } catch (error) {
      console.error('Search failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddToPipeline = async (creatorId) => {
    try {
      // In a real app, we'd show a modal to select pipeline and stage
      await api.post('/api/pipeline/default/candidates', 
        { creatorId, stage: 'new' }
      );
      alert('Candidate added to pipeline!');
    } catch (error) {
      console.error('Failed to add to pipeline:', error);
      alert('Failed to add candidate');
    }
  };

  return (
    <div>
      <Navbar user={user} onLogout={onLogout} userType="recruiter" />
      
      <div className="search-container">
        <div className="search-header">
          <h1>Talent Discovery</h1>
          <p className="text-gray-600">AI-powered search across fashion portfolios</p>
        </div>

        {/* Search Bar */}
        <div className="search-bar card">
          <input
            type="text"
            className="search-input"
            placeholder="Search by name, skill, or keyword..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
          />
          <button className="btn btn-primary" onClick={handleSearch}>
            🔍 Search
          </button>
        </div>

        <div className="search-layout">
          {/* Filters Sidebar */}
          <div className="filters-panel card">
            <h3>Filters</h3>
            
            <div className="filter-group">
              <label>Style</label>
              <select
                className="input"
                value={filters.style}
                onChange={(e) => setFilters({...filters, style: e.target.value})}
              >
                <option value="">All Styles</option>
                <option value="minimalist">Minimalist</option>
                <option value="bohemian">Bohemian</option>
                <option value="avant-garde">Avant-Garde</option>
                <option value="techwear">Techwear</option>
                <option value="streetwear">Streetwear</option>
                <option value="classic">Classic</option>
              </select>
            </div>

            <div className="filter-group">
              <label>Material</label>
              <select
                className="input"
                value={filters.material}
                onChange={(e) => setFilters({...filters, material: e.target.value})}
              >
                <option value="">All Materials</option>
                <option value="silk">Silk</option>
                <option value="cotton">Cotton</option>
                <option value="denim">Denim</option>
                <option value="leather">Leather</option>
                <option value="wool">Wool</option>
                <option value="Gore-Tex">Gore-Tex</option>
              </select>
            </div>

            <div className="filter-group">
              <label>Garment Type</label>
              <select
                className="input"
                value={filters.garmentType}
                onChange={(e) => setFilters({...filters, garmentType: e.target.value})}
              >
                <option value="">All Types</option>
                <option value="dress">Dress</option>
                <option value="jacket">Jacket</option>
                <option value="pants">Pants</option>
                <option value="coat">Coat</option>
              </select>
            </div>

            <div className="filter-group">
              <label>Location</label>
              <input
                type="text"
                className="input"
                placeholder="City or region"
                value={filters.location}
                onChange={(e) => setFilters({...filters, location: e.target.value})}
              />
            </div>

            <button className="btn btn-primary btn-block" onClick={handleSearch}>
              Apply Filters
            </button>

            <button 
              className="btn btn-secondary btn-block"
              onClick={() => setFilters({ style: '', material: '', garmentType: '', location: '' })}
            >
              Clear All
            </button>
          </div>

          {/* Results Grid */}
          <div className="results-section">
            <div className="results-header">
              <h2>{results.length} Designers Found</h2>
            </div>

            {loading ? (
              <div className="loading">Searching...</div>
            ) : (
              <div className="results-grid">
                {results.map(creator => (
                  <div key={creator.id} className="creator-card card">
                    <div className="creator-header">
                      <img
                        src={creator.profileImage}
                        alt={creator.name}
                        className="creator-avatar"
                      />
                      <div className="creator-info">
                        <h3>{creator.name}</h3>
                        <p className="creator-title">{creator.title}</p>
                        <p className="creator-location">📍 {creator.location}</p>
                      </div>
                    </div>

                    <div className="creator-portfolio">
                      <div className="portfolio-images">
                        {creator.portfolio.featured.map((img, idx) => (
                          <img key={idx} src={img} alt={`Work ${idx + 1}`} />
                        ))}
                      </div>
                    </div>

                    <div className="creator-tags">
                      {creator.portfolio.style.map((style, idx) => (
                        <span key={idx} className="badge badge-info">{style}</span>
                      ))}
                    </div>

                    <div className="creator-meta">
                      <span>📁 {creator.portfolio.projectCount} projects</span>
                    </div>

                    <div className="creator-actions">
                      <Link 
                        to={`/recruiter/candidate/${creator.id}`}
                        className="btn btn-secondary btn-sm"
                      >
                        View Profile
                      </Link>
                      <button 
                        className="btn btn-primary btn-sm"
                        onClick={() => handleAddToPipeline(creator.id)}
                      >
                        + Add to Pipeline
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TalentSearch;
